<template>
  <label for="year_of_study" class="block text-sm font-medium text-gray-700">Year of study</label>
  <v-select
    data-cy="year-of-study"
    v-model="yearOfStudy"
    :options="options"
    multiple
    taggable
    @option:selected="toggleSelect"
  ></v-select>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'YearOfStudy',
  components: {
    vSelect,
  },
  mounted() {
    this.splitYearOfStudy();
  },
  emits: ['yearOfStudyChanged'],
  data() {
    return {
      yearOfStudy: [],
      options: ['1st', '2nd', '3rd', '4th'],
    };
  },
  methods: {
    toggleSelect() {
      console.log(this.yearOfStudy);
      const joinedYears = this.yearOfStudy.join(', ');
      this.$emit('yearOfStudyChanged', joinedYears);
    },
    splitYearOfStudy() {
      const years = this.$page.props.session?.details?.year_of_study ?? [];

      if (years.length) {
        this.yearOfStudy = years.split(',').map((item) => item.trim());
      } else {
        this.yearOfStudy = years;
      }
    },
  },
};
</script>

<style scoped></style>
